module.exports = __webpack_public_path__ + "img/check-approve-ok.6b804656.png";